// extracted by mini-css-extract-plugin
export var card = "ReviewInfo-module--card--cdaea";
export var fadeInAnimation = "ReviewInfo-module--fadeInAnimation--f38a9";
export var hideMobile = "ReviewInfo-module--hideMobile--472f0";
export var hideTablet = "ReviewInfo-module--hideTablet--5962d";
export var location = "ReviewInfo-module--location--4faaa";
export var locationImg = "ReviewInfo-module--locationImg--ec7b7";
export var logo = "ReviewInfo-module--logo--227f9";
export var logoWrapper = "ReviewInfo-module--logoWrapper--3bcdd";
export var mediaPlayer = "ReviewInfo-module--mediaPlayer--dfb2a";
export var popupLink = "ReviewInfo-module--popupLink--357c0";
export var review = "ReviewInfo-module--review--68fcc";
export var reviewPlatform = "ReviewInfo-module--reviewPlatform--b475b";
export var section = "ReviewInfo-module--section--987ea";
export var shortDescription = "ReviewInfo-module--shortDescription--307c5";
export var slider = "ReviewInfo-module--slider--fe29d";
export var text = "ReviewInfo-module--text--6d98e";
export var title = "ReviewInfo-module--title--96477";
export var wrapper = "ReviewInfo-module--wrapper--1c293";